

































































import { Component, Prop, Provide, Vue } from 'vue-property-decorator';

import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TPatient } from '@/plugins/podolib/services/entities/EntityPatients';
import { TStation } from '@/plugins/podolib/services/entities/EntityStations';
// Components
import DialogAcquisitionInProgress from '@/components/dialogs/DialogAcquisitionInProgress.vue';
import DialogStartAnalysisWithoutConnectedStation from '@/components/dialogs/DialogStartAnalysisWithoutConnectedStation.vue';

@Component({
  components: {
    DialogAcquisitionInProgress,
    DialogStartAnalysisWithoutConnectedStation,
  },
})
export default class PatientFileBanner extends Vue {
  @Prop({ required: true }) private readonly patient!: TEntity<TPatient>;

  // Dialogs open values
  acquisitionInProgressDialog = false;
  noStationAvailableDialog = false;

  get startAcquisitionLinkLocked() {
    return this.$pdc.helper!.isDemo || !this.$pdc.entities!.stations.storedEntity.list.length;
  }

  // Has connected station ?
  get connectedStations() {
    return this.$pdc.analysis!.entityStations!.data.filter((x: TEntity<TStation>) => x.online).length;
  }

  // Is an analysis in progress ?
  get isInProgressAnalysis() {
    return Vue.prototype.$pdc.analysis.manifestHasData;
  }

  // Edit patient
  openPatientEdit() {
    this.$pdc.bus!.emit('patient:edit', this.patient._id);
  }
  // Remove patient
  openPatientDelete() {
    this.$pdc.bus!.emit('patient:removed', this.patient);
  }

  // Move to acquisition module
  goToAcquisition() {
    if (this.startAcquisitionLinkLocked) {
      this.$pdc.bus!.emit('equipments:get-kit:open');
    } else {
      if (this.$pdc.analysis!.manifestHasData) {
        this.acquisitionInProgressDialog = true;
      } else if (!this.connectedStations!) {
        this.noStationAvailableDialog = true;
      } else {
        // Analytics
        this.$pdc.analytics?.actions.trackSuccess('NewAnalysis Opened', {
          patientId: this.patient._id,
        });

        this.$router.push({
          path: '/analysis',
          query: {
            patientId: this.patient._id,
          },
        });
      }
    }
  }

  // Close dialogs
  closeAnalysisDialog() {
    this.acquisitionInProgressDialog = false;
  }
  closeNoStationDialog() {
    this.noStationAvailableDialog = false;
  }
}
